import { Box, CircularProgress, Typography } from '@material-ui/core';
import React from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { mediaService } from 'shared/services/mediaService';
import { NoMediaCont } from '../MediaBinModal.styles';
import { MainCont } from './AudioBin.styles';
import AudioBinItem from './AudioBinItem';

interface Props {
  addMedia: (medias: IMedia) => void;
  selected: IMedia[];
  media?: IMedia[];
  attached: boolean;
}
const { getMediaList } = mediaService();

const AudioBin: React.FC<Props> = ({ addMedia, selected, media, attached }) => {
  const { data: mediaData, isLoading: isMediaLoading } = getMediaList({ file_type: 'audio', media_bin: true });

  const item = attached ? media : mediaData?.data;

  return isMediaLoading ? (
    <Box style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress style={{ width: 25, height: 25, marginRight: 10 }} /> <Typography>Fetching Data...</Typography>
    </Box>
  ) : (
    <MainCont>
      {item?.length ? (
        item.map((m) => (
          <AudioBinItem
            key={m.id}
            checked={selected.filter((f) => f.id === m.id).length > 0}
            item={m}
            handleSelect={addMedia}
          />
        ))
      ) : (
        <NoMediaCont>
          <Typography style={{ marginTop: 50 }}>No Media Available</Typography>
        </NoMediaCont>
      )}
    </MainCont>
  );
};

export default AudioBin;
